module.exports = __webpack_public_path__ + "static/media/browse-icon.616fa9b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/browse-icon.svg
// module id = 862
// module chunks = 21